import React from 'react';
import './App.css';
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
// import {getUserInfo} from './utils/tool.js'
import {useTitle} from './utils/useFunc';

// import Home from "./views/Home"
import NotFound from "./views/NotFound"
// 19.9介绍页
import P1 from "./views/P1";
// 9.9介绍页
import P2 from "./views/P2";
// 8.8介绍页
import P3 from "./views/P3";
// 结果页 二维码页
import Result from "./views/Result";
// 登录页
// import Login from "./views/Login";
// // 协议详情页
// import protocolDe from "./views/ProtocolDetails"
// // 订单信息页面
// import oderInfo from "./views/OderInfo"
// // 测试页
// import testPage from "./views/testPage"
// 微信app内支付
import Wxpay from "./views/Wxpay";
// 微信外部支付中间页
import Wxoitpay from "./views/internalPage"


// 验证登录
function verify() {
  return localStorage.getItem("key") && localStorage.getItem("member_id")
  // 测试
  // return true
}
/**
 * 自定义路由
 * @param {{path: string, component: any, verify: () => boolean}} props path 路径 component 组件 verify验证函数
 */
function IRoute(props) {
  let Component = props.component
  let verify = props.verify
  let W = () => {
    if (verify && !verify()) {
      return <Redirect to={{pathname: '/p1'}}/>
    } else {
      return <Component/>
    }
  }
  return <Route exact path={props.path}><W/></Route>
}
function App() {
  let title;
  if(window.location.hash.search("p1") !== -1){
    title = '股市生存·冠军特训营'
  }else {
    title = '证券学院•小牛学习营'
  }
  useTitle(title)
  return (
    <div className="App">
      <Router>
        <Switch>
          {/* <Route exact path="/"><Home /></Route> */}
          <IRoute path="/p1" component={P1}></IRoute>
          <IRoute path="/result" component={Result} verify={verify} redirectPathname='/p1'></IRoute>
          <IRoute path="/p2" component={P2}></IRoute>
          <IRoute path="/result" component={Result} verify={verify} redirectPathname='/p2'></IRoute>
          <IRoute path="/p3" component={P3}></IRoute>
          <IRoute path="/result" component={Result} verify={verify} redirectPathname='/p3'></IRoute>
          {/* <IRoute path="/login" component={Login} verify={verify}></IRoute> */}
          {/* <IRoute path="/protocolDe" component={protocolDe} ></IRoute> */}
          <IRoute path="/wxpay" component={Wxpay} ></IRoute>
          <IRoute path="/Wxoitpay" component={Wxoitpay}></IRoute>
          {/* <IRoute path="/oderInfo" component={oderInfo} verify={verify}></IRoute> */}
          {/* <IRoute path="/testPage" component={testPage} verify={verify}></IRoute> */}
          <Route path="*"><NotFound /></Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
